export function sizeNavbar() {
  const sitesWithoutTopCookies = ['The International', 'NBA Experiences', 'MotoGP™ Premier', 'LIV Golf']

  if ($('.cookie-consent-dropdown').length == 0 || sitesWithoutTopCookies.includes(window.brand_name)) { return }

  $('.navbar-fixed-top').css('top', 0)
  $('.navbar-fixed-top .navbar-default').css('top',
    `${$('.cookie-fixed-top .nav-cookies').height()}px`)
}
